import React from 'react';
import Auth from './Auth';
import AuthFooter from './AuthFooter';
import AuthPageShell from './AuthPageShell';

function AuthSection(props) {
  const withNext = path =>
    props.afterAuthPath ? `${path}?next=${encodeURIComponent(props.afterAuthPath)}` : path;

  // Options by auth type
  const optionsByType = {
    signup: {
      // Top Title
      title: 'Get yourself an account',
      // Button text
      buttonAction: 'Sign up',
      // Footer text and links
      showFooter: true,
      signinText: 'Already have an account?',
      signinAction: 'Sign in',
      signinPath: withNext('/auth/signin'),
      // Terms and privacy policy agreement
      showAgreement: true,
      termsPath: '/legal/terms-of-service',
      privacyPolicyPath: '/legal/privacy-policy',
    },
    signin: {
      title: 'Welcome back',
      buttonAction: 'Sign in',
      showFooter: true,
      signupAction: 'Create an account',
      signupPath: withNext('/auth/signup'),
      forgotPassAction: 'Forgot Password?',
      forgotPassPath: withNext('/auth/forgotpass'),
    },
    forgotpass: {
      title: 'Get a new password',
      buttonAction: 'Reset password',
      showFooter: true,
      signinText: 'Remember your password?',
      signinAction: 'Sign in',
      signinPath: withNext('/auth/signin'),
    },
    changepass: {
      title: 'Choose a new password',
      buttonAction: 'Change password',
    },
  };

  // Ensure we have a valid auth type
  const type = optionsByType[props.type] ? props.type : 'signup';

  // Get options object for current auth type
  const options = optionsByType[type];

  const title =
    (props.type === 'signin' && 'Sign in to your account') ||
    (props.type === 'signup' && 'Sign up for an account') ||
    (props.type === 'forgotpass' && 'Reset your password');

  return (
    <AuthPageShell
      title={title}
      footer={options.showFooter && <AuthFooter type={type} {...options} />}
    >
      {(type === 'signin' || type === 'signup') && props.afterAuthPath === '/admin/apply' && (
        <div className="mb-4 text-sm text-slate-600 bg-slate-50 border border-slate-200 rounded-md p-3">
          Requesting access for a gallery or organization? We recommend using your
          organization's work email (e.g. name@yourgallery.com) rather than a personal one.
        </div>
      )}
      {props.authError && <div className="mb-4 text-sm text-red-600">{props.authError}</div>}
      <Auth
        type={type}
        buttonAction={options.buttonAction}
        providers={props.providers}
        afterAuthPath={props.afterAuthPath}
        key={type}
      />
    </AuthPageShell>
  );
}

export default AuthSection;
